import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

// styles
import colors from '../../../styles/colors'

//components
import Empty from '../../reviewList/components/Empty'

// images
import QImg from '../../../assets/image/Q.svg'
import DownImg from '../../../assets/image/arrow/ic-down.svg'
import { useAxios } from '../../../utils/useAxios'
import * as constants from '../../../globals/constants'
import * as TYPE from '../../../globals/type'

const Questions = ({
  selectedIdx,
  selectedFAQItem,
  handleFAQAccordion,
  setSelectedFAQItem,
  setSelectedIdx,
}) => {
  const [items, setItems] = useState([])
  const [allItems, setAllItems] = useState([])

  const { fetchData, loading, data, error } = useAxios()
  useEffect(() => {
    // if (selectedIdx == 1) {
    fetchData(constants.API.FAQ_LIST, 'GET', null, null)
    // }
  }, [])

  useEffect(() => {
    if (data?.responseCode == TYPE.API_RESPONSE.SUCCESS) {
      if (Array.isArray(data.responseData)) {
        setAllItems(data.responseData)
        let filteredItems = []
        const category = '회원'
        data.responseData.filter((item) => {
          if (item.category === category) {
            filteredItems.push(item)
          }
        })
        setItems(filteredItems)
      }
    }
  }, [data])

  const filterItems = (category) => {
    let filteredItems = []
    allItems.filter((item) => {
      if (item.category === category) {
        filteredItems.push(item)
      }
    })
    setItems(filteredItems)
  }
  const handleFAQTab = (idx, category) => {
    filterItems(category)
    setSelectedFAQItem([])
    setSelectedIdx(idx)
  }

  return (
    <>
      <FAQTabs>
        {['회원', '주문', '카테고리'].map((item, idx) => (
          <FAQTabBtn
            isSelected={selectedIdx === idx}
            onClick={() => handleFAQTab(idx, item)}
            key={idx}
          >
            {item}
          </FAQTabBtn>
        ))}
      </FAQTabs>

      {items ? (
        <FAQBox>
          {items.map((item, idx) => (
            <ItemWrapper key={idx}>
              <HeaderItem isActive={selectedFAQItem.includes(idx)}>
                <img src={QImg} />
                <div onClick={() => handleFAQAccordion(idx)}>{item.title}</div>
                <img src={DownImg} onClick={() => handleFAQAccordion(idx)} />
              </HeaderItem>
              {selectedFAQItem.includes(idx) && (
                <BodyItem>{item.description}</BodyItem>
              )}
            </ItemWrapper>
          ))}
        </FAQBox>
      ) : (
        <Wrapper>
          <Empty pointTxt={'등록된 FAQ'} txt={'가 없습니다.'} />
        </Wrapper>
      )}
    </>
  )
}

export default Questions

const FAQTabs = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;

  margin-bottom: 30px;
  @media ${(props) => props.theme.mobile} {
    padding: 20px 20px 0;
  }
`

const FAQTabBtn = styled.button`
  padding: 8px 15px;
  border-radius: 17px;
  background-color: ${(props) =>
    props.isSelected ? `${colors.mainG}` : `${colors.G3}`};
  text-align: center;
  font-size: 16px;
  color: ${(props) => (props.isSelected ? `${colors.W1}` : `${colors.BK}`)};
`

const ItemWrapper = styled.div`
  padding-top: 20px;
  display: flex;
  flex-direction: column;

  @media ${(props) => props.theme.mobile} {
    padding: 20px 20px 0 20px;
  }
`

const HeaderItem = styled.div`
  display: flex;
  align-items: center;
  padding: 0 20px;

  @media ${(props) => props.theme.mobile} {
    padding: 0;
  }

  img:nth-child(1) {
    width: 16px;
    height: 29px;
    margin-right: 46px;

    @media ${(props) => props.theme.mobile} {
      margin-right: 20px;
    }
  }

  img:nth-child(3) {
    width: 12px;
    height: 12px;
    cursor: pointer;
    transition: transform 0.5s ease;
    transform: ${(props) =>
      props.isActive ? `rotate(180deg)` : `rotate(0deg)`};
  }

  div {
    flex: 1;
    font-size: 16px;
    color: ${colors.BK};
    cursor: pointer;
  }
`

const BodyItem = styled.div`
  margin-top: 20px;
  padding: 20px;
  border-radius: 8px;
  background-color: ${colors.W4};
  font-size: 16px;
  line-height: 1.56;
  word-break: break-all;
  white-space: pre-wrap;
  color: ${colors.BK};
`

const FAQBox = styled.div`
  border-top: 1px solid #e5e5e5;
`

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media ${(props) => props.theme.mobile} {
    padding: 0 20px;
  }
`
